import { getStatusConfigByLabel, StatusConfig } from 'src/utils/statusUtils';
import FontAwesomeIcon from 'src/components/Icon';
import IcoMoon from 'src/components/IcoMoon';
import './StatusIcon.scss';

interface StatusIconProps {
  status: string;
  showLabel?: boolean;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const StatusIcon = ({
  status,
  showLabel = true,
  size = 'medium',
  className = '',
}: StatusIconProps) => {
  const statusConfig: StatusConfig = getStatusConfigByLabel(status);

  const renderIcon = () => {
    // Handle special FontAwesome cases (same logic as original StatusOverviewCard).
    if (statusConfig.label === 'Under Review') {
      return (
        <FontAwesomeIcon glyph="hourglass-end" weight="light" size="solid" />
      );
    }

    if (statusConfig.label === 'One Year Warranty') {
      return (
        <FontAwesomeIcon glyph="certificate" weight="solid" size="solid" />
      );
    }

    return <IcoMoon glyph={statusConfig.glyph} />;
  };

  return (
    <div className={`status-icon status-icon--${size} ${className}`}>
      <div className="status-icon__icon">{renderIcon()}</div>
      {showLabel && (
        <span className="status-icon__label">{statusConfig.label}</span>
      )}
    </div>
  );
};

export default StatusIcon;
